import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUpFrom2.css";
import Swal from 'sweetalert2';
import { baseURLs } from "../constants";
import axios from "axios";




const SignUpForm = () => {

  const navigate = useNavigate();
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    personalID: "",
    studentId: "",
    firstname_old: "",
    lastname_old: "",
    Type_member: "",
  });

  const handleShowTermsModal = () => {
    const { firstName, lastName, personalID, Type_member } = formData;
    console.log(Type_member)
    if (!firstName || !lastName || !personalID || !Type_member.trim() ) {
      Swal.fire({
        icon: "warning",
        title: "ข้อมูลไม่ครบถ้วน!",
        text: "กรุณากรอกข้อมูลให้ครบ: ชื่อ, นามสกุล, รหัสบัตรประชาชน และเลือกประเภทผู้ใช้งาน",
      });
    } else {
      setShowTermsModal(true);
    }
  };


  const handleCloseTermsModal = () => setShowTermsModal(false);
  const handleTermsChange = (e) => setIsTermsAccepted(e.target.checked);
  const handleSubmit = async (e) => {
    e.preventDefault();




    const metadata = {
      firstName: formData.firstName || "",
      lastName: formData.lastName || "",
      personalID: formData.personalID || "",
      // firstname_old: formData.firstname_old || "",
      // lastname_old: formData.lastname_old || "",
      studentCode: formData.studentId || "",
      Type_member: getTypeMemberNum(formData.Type_member),
    };

    function getTypeMemberNum(type) {
      switch (type) {
        case "ศิษย์เก่า":
          return "1";
        case "บุคลากร (พนักงานมหาวิทยาลัย)":
          return "2";
        case "บุคลากร (ข้าราชการ)":
          return "3";
        default:
          return "";
      }
    }
    const { Type_member } = formData;
    if (!Type_member.trim() ) {
      Swal.fire({
        icon: "warning",
        title: "ข้อมูลไม่ครบถ้วน!",
        text: "กรุณากรอกข้อมูลให้ครบ: ชื่อ, นามสกุล, รหัสบัตรประชาชน และเลือกประเภทผู้ใช้งาน",
      });
      return;
    }
    const formDataObj = new FormData();
    formDataObj.append("Metadata", JSON.stringify(metadata));
    console.log("Metadata being sent:", metadata);
    try {
      Swal.fire({
        title: "กำลังตรวจสอบข้อมูล...",
        text: "โปรดรอสักครู่",
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axios.post(

        `${baseURLs.api}/Home/CheckAlready_AlumniMember`,
        formDataObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );
      Swal.close();


      if (!isTermsAccepted) {
        Swal.fire({
          title: "กรุณายอมรับเงื่อนไข!",
          text: "กรุณาอ่านและยอมรับข้อกำหนดและเงื่อนไขก่อนสมัครสมาชิก",
        });
        return;
      }

      if (response.status === 200 && response.data) {
        if (response.data == "True") {
          Swal.fire({
            icon: "success",
            title: "คุณมีสิทธิ์ที่จะสมัครสมาชิก!",
            text: "คุณสามารถเข้าสู่ระบบต่อไปได้แล้ว",
          }).then(() => {

            const queryString = new URLSearchParams({
              firstName: formData.firstName,
              lastName: formData.lastName,
              Type_member: formData.Type_member,
              personalID: formData.personalID,
            }).toString();

            window.location.href = `/RegisterAssoc/SignUp?${queryString}`;

          });
        } else if (response.data === "มีข้อมูลอยู่ในระบบแล้ว") {

          Swal.fire({
            icon: "warning",
            title: "มีข้อมูลอยู่ในระบบแล้ว!",
            text: "คุณเป็นสมาชิกอยู่แล้ว โปรดตรวจสอบข้อมูล ",
          }).then(() => {
            navigate("/Check");
          });

        } else {

          Swal.fire({
            icon: "error",
            title: "ไม่สามารถสมัครได้",
            text: "ไม่พบข้อมูลหรือไม่เข้าเงื่อนไขในการสมัครสมาชิก",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด!",
          text: "ไม่สามารถตรวจสอบข้อมูลได้ โปรดลองอีกครั้ง",

        });
      }
    } catch (err) {

      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด!",
        text: err.message || "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ โปรดลองใหม่อีกครั้ง",
      });
    }
  };
  const formatThaiID = (id) => {
    return id
      .replace(/\D/g, '')
      .slice(0, 13)
      .replace(/^(\d{1})(\d{0,4})?(\d{0,5})?(\d{0,2})?(\d{0,1})?$/,
        (_, p1, p2 = "", p3 = "", p4 = "", p5 = "") =>
          `${p1}${p2 ? "-" + p2 : ""}${p3 ? "-" + p3 : ""}${p4 ? "-" + p4 : ""}${p5 ? "-" + p5 : ""}`
      );
  }
  const handleInputChange = (e) => {
    const { id, name, value, type } = e.target;

    let sanitizedValue = value || "";

    if (type === "radio" && name === "Type_member") {
      setFormData((prevData) => ({
        ...prevData,
        Type_member: sanitizedValue,
      }));
    } else {
      if (id === "firstName" || id === "lastName" || id === "firstNameold" || id === "lastNameold") {
        sanitizedValue = sanitizedValue.replace(/[^a-zA-Zก-๙\s]/g, "");
      } else if (id === "personalID") {
        sanitizedValue = formatThaiID(sanitizedValue);
      } else if (id === "personalID" || id === "studentId") {
        sanitizedValue = sanitizedValue.replace(/\D/g, "");
      }

      setFormData((prevData) => ({
        ...prevData,
        [id]: sanitizedValue,
      }));
    }
  };


  return (
    <div className="container-fluid signup-page"
      style={{
        backgroundImage: "url('/RegisterAssoc/tower.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >

      <div className="row justify-content-center align-items-center min-vh-100">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow p-4">
            <h2 className="text-center mb-4">Sign Up</h2>
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* First Name & Last Name ในบรรทัดเดียวกัน */}
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="firstName">
                      ชื่อ (FirstName) <span className="text-danger">*</span></label>
                    <input
                      Type_member="text"
                      className="form-control"
                      id="firstName"
                      placeholder="ใส่ชื่อของคุณ"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                {/* LastfirstName */}
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label htmlFor="lastName">นามสกุล (LastName)<span className="text-danger">*</span></label>
                    <input
                      Type_member="text"
                      className="form-control"
                      id="lastName"
                      placeholder="ใส่นามสกุลของคุณ"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                {/* ID Card */}
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="personalID">เลขบัตรประจำตัวประชาชน (ID Card)<span className="text-danger">*</span></label>
                    <input
                      Type_member="text"
                      className="form-control"
                      id="personalID"
                      placeholder="ใส่เลขบัตรประจำตัวประชาชนของคุณ"
                      value={formData.personalID}
                      onChange={handleInputChange}
                      maxLength={17}
                      required
                    />
                  </div>
                </div>
                {/* Student ID */}
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="studentId">รหัสนักศึกษา (Student ID) (ถ้ามี)</label>
                    <input
                      Type_member="text"
                      className="form-control"
                      id="studentId"
                      placeholder="ใส่รหัสนักศึกษาของคุณ (ถ้ามี)"
                      value={formData["studentId"]}
                      onChange={handleInputChange}
                      maxLength={7}
                    />
                  </div>
                </div>
                {/* Name Old & LastfirstName Old */}
                {/* <div className="col-12">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstname_old">ชื่อเก่า (ถ้ามี)</label>
                      <input
                        Type_member="text"
                        className="form-control"
                        id="firstname_old"
                        placeholder="ใส่ชื่อเก่าของคุณ"
                        value={formData.firstname_old}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="lastname_old">นามสกุลเก่า (ถ้ามี)</label>
                      <input
                        Type_member="text"
                        className="form-control"
                        id="lastname_old"
                        placeholder="ใส่นามสกุลเก่าของคุณ"
                        value={formData.lastname_old}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div> */}

                {/* User Type */}
                <div className="col-12">
                  <label>ประเภทผู้ใช้งาน(Member Type) <span className="text-danger">*</span></label>
                  <div>
                    {["ศิษย์เก่า", "บุคลากร (พนักงานมหาวิทยาลัย)", "บุคลากร (ข้าราชการ)"].map((option) => (
                      <div className="form-check" key={option}>
                        <input
                          type="radio"
                          className="form-check-input"
                          name="Type_member"
                          id={`Type_member-${option}`}
                          value={option}
                          checked={formData.Type_member === option}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor={`Type_member-${option}`}>{option}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2 mt-4">
                <button
                  Type_member="button"
                  className="btn btn-primary btn-lg"
                  onClick={handleShowTermsModal}
                >
                  ตรวจสอบก่อนสมัครสมาชิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Terms Modal */}
      {showTermsModal && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h4 className="modal-title text-red-500">
            </h4>
            <div className="modal-body">
              <iframe
                className="pdf-viewer"
                src="/RegisterAssoc/PDPA.pdf"
                title="PDF Viewer"
                style={{ width: "80%", height: "50vh", border: "none", overflow: "auto", WebkitOverflowScrolling: "touch" }}
              ></iframe>

              <p>หากไม่สามารถแสดงไฟล์ได้ กรุณาดาวน์โหลด:</p>
              <a
                href="/RegisterAssoc/PDPA.pdf"
                download
                className="btn btn-link"
              >
                ดาวน์โหลด PDF
              </a>
              <p>หรือคลิกเพื่อเปิดข้อกำหนดในแท็บใหม่:</p>
              <a href="/RegisterAssoc/PDPA.pdf" target="_blank" className="btn btn-link">
                เปิด PDF ในแท็บใหม่</a>
            </div>
            <div className="form-check d-flex justify-content-center align-items-center">
              <input
                Type="checkbox"
                className="form-check-input me-2"
                id="termsCheck"
                checked={isTermsAccepted}
                onChange={handleTermsChange}
              />
              <label htmlFor="termsCheck" className="form-check-label mb-0">
                ฉันได้อ่านและรับทราบข้อกำหนดและเงื่อนไขทั้งหมดแล้ว
              </label>
            </div>
            <div className="d-flex justify-content-center mt-4 gap-3">
              <button
                className="btn btn-primary mt-4"
                onClick={handleSubmit}
                disabled={!isTermsAccepted}
              >
                สมัครสมาชิก
              </button>
              <button
                className="btn btn-secondary mt-4"
                onClick={handleCloseTermsModal}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      )}
    </div>


  );
};

export default SignUpForm;
